import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-planner-mapper-wrapper',
  templateUrl: './planner-mapper-wrapper.component.html',
  styleUrls: ['./planner-mapper-wrapper.component.css']
})
export class PlannerMapperWrapperComponent implements OnInit {
  selectedTab = 'vehicles'; // Default tab
  constructor() { }

  ngOnInit() {
  }

  setTab(tab: string) {
    this.selectedTab = tab;
  }

}
